export default "__VITE_ASSET__DydES6tE__"